import { SnowboardModel } from '../types/snowboard'
import '../styles/ModelCard.css'

interface ModelCardProps {
  model: SnowboardModel
  isSelected: boolean
  onSelect: (model: SnowboardModel) => void
}

export function ModelCard({ model, isSelected, onSelect }: ModelCardProps) {
  return (
    <div
      className={`model-card ${isSelected ? 'selected' : ''}`}
      onClick={() => onSelect(model)}
    >
      <div className="image-container">
        <img src={model.imageUrl} alt={model.name} className="model-image" />
      </div>
      <div className="model-info">
        <h3>{model.name}</h3>
        <p>{model.description}</p>
        <div className="size-tags">
          {model.sizes.map(size => (
            <span key={size.size} className="size-tag">
              {size.size}
            </span>
          ))}
        </div>
      </div>
    </div>
  )
}